import React, { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate, Outlet } from "react-router-dom";
import { useReturn } from "util/return";
import { useSetTitle } from "util/title";

import { Container, Message, Button, Box } from "react-bulma-components";
import IconButton from "util/iconButton";

import { FaTimes, FaEdit } from "react-icons/fa";

import { profileSlice } from "redux/features/profile";
import EditAffiliationStatus from "./edit";
import { getStatusSummary } from "./common";
import { ShowOriginalStatusRecord } from "./statusDetails";

import ChangeAffiliationStartDate from "./changeStartDate";
import { usePreloadInstitutionOptions } from "./institution";

function DisplayDates({ data }) {
  const { dateSpecifier } = useParams();
  const [statusRecord] = getStatusSummary(data).filter(
    (r) => r.through === dateSpecifier
  );
  return statusRecord ? (
    <Fragment>
      {": "}
      {statusRecord.showFrom ? " from " + statusRecord.showFrom : null}
      {statusRecord.showThrough ? " through " + statusRecord.showThrough : null}
    </Fragment>
  ) : null;
}

export function PastAffiliationSectionLayout({
  headerText,
  headerDetails = null,
  children,
}) {
  const doClose = useReturn();
  return (
    <Container className="spaced">
      <Message>
        <Message.Header>
          {headerText}
          {headerDetails}
          <Button remove onClick={doClose} />
        </Message.Header>
        <Message.Body className="basic-edit-affiliation">
          {children}
        </Message.Body>
      </Message>
    </Container>
  );
}

export function EditPastAffiliation() {
  const { data } = useSelector(profileSlice.selector);

  const { dateSpecifier } = useParams();
  const institutionOptions = usePreloadInstitutionOptions();
  if (!institutionOptions.loaded)
    return (
      <Container className="spaced">
        Loading data from server; please wait.
      </Container>
    );

  return (
    <PastAffiliationSectionLayout
      headerText=" Correcting Past Affiliation/Occupation"
      headerDetails={<DisplayDates data={data} />}
    >
      <EditAffiliationStatus dateSpecifier={dateSpecifier} />
    </PastAffiliationSectionLayout>
  );
}

export function ReviewPastAffiliations() {
  const { id, data } = useSelector(profileSlice.selector);
  const doClose = useReturn();

  const [, ...pastStatusRecordsNewestFirst] = getStatusSummary(data).reverse();
  const pastStatusRecords = pastStatusRecordsNewestFirst.reverse();
  const navigate = useNavigate();
  const [changingDate, setChangingDate] = useState(null);

  return (
    <PastAffiliationSectionLayout headerText="Past Affiliations/Occupations">
      <div className="block affiliation-status-list">
        {pastStatusRecords.map((statusRecord, index) => (
          <Box key={index}>
            <ShowOriginalStatusRecord statusRecord={statusRecord} isPast />
            {changingDate === statusRecord.through ? (
              <ChangeAffiliationStartDate
                id={id}
                statusRecord={statusRecord}
                onFinished={() => setChangingDate(null)}
              />
            ) : changingDate == null ? (
              <div className="buttons">
                <IconButton
                  icon={FaEdit}
                  onClick={(e) => navigate(statusRecord.through)}
                >
                  Edit Details
                </IconButton>
                {statusRecord.isFirst ? null : (
                  <IconButton
                    icon={FaEdit}
                    onClick={(e) => setChangingDate(statusRecord.through)}
                  >
                    Change Start {statusRecord.roundedFrom ? "Month" : "Date"}
                  </IconButton>
                )}
              </div>
            ) : null}
          </Box>
        ))}
      </div>
      <div className="buttons block">
        <IconButton icon={FaTimes} onClick={doClose}>
          Close
        </IconButton>
      </div>
    </PastAffiliationSectionLayout>
  );
}

export function PastAffiliationLayout() {
  useSetTitle("Past Affiliations/Occupations");
  return (
    <Container className="spaced">
      <Outlet />
    </Container>
  );
}
